import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import FuturisticBot from './FuturisticBot';
import ConsultationModal from './ConsultationModal';

import EditableText from '@/components/cms/EditableText';
const HeroSection = () => {
  const [isConsultationOpen, setIsConsultationOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      {/* Futuristic Grid Background - Full Coverage */}
      <div className="absolute inset-0 z-0">
        <FuturisticBot />
      </div>

      {/* Subtle overlay for text readability */}
      <div className="absolute inset-0 z-0 bg-gradient-to-br from-background/20 via-transparent to-background/30"></div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-6xl mx-auto">
        <div className="animate-slide-up">
          {/* Main Headline */}
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-display font-bold mb-6 leading-tight">
            <EditableText k="hero.companyName" as="span" className="gradient-text" />
            <br />
            <EditableText k="hero.tagline" as="span" className="text-accent" />
          </h1>

          {/* Subtitle */}
          <EditableText k="hero.transformBusiness" as="p" multiline className="text-xl md:text-2xl text-muted-foreground mb-12 max-w-3xl mx-auto leading-relaxed" />

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button 
              size="lg" 
              className="gradient-primary text-lg px-8 py-6 rounded-full glow-primary pulse-glow transition-spring hover:scale-105 group"
              onClick={() => setIsConsultationOpen(true)}
            >
              <EditableText k="hero.freeConsultation" />
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            
            <Button 
              variant="outline" 
              size="lg" 
              className="text-lg px-8 py-6 rounded-full border-primary/50 text-primary hover:bg-primary hover:text-primary-foreground transition-spring hover:scale-105"
              onClick={() => scrollToSection('references')}
            >
              <EditableText k="hero.viewOurWork" />
            </Button>
          </div>
        </div>

      </div>

      {/* Consultation Modal */}
      <ConsultationModal 
        open={isConsultationOpen} 
        onOpenChange={setIsConsultationOpen} 
      />

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        {/* Mouse scroll icon - responsive for mobile and desktop */}
        <div className="w-5 h-8 sm:w-6 sm:h-10 border-2 border-primary/50 rounded-full flex justify-center">
          <div className="w-1 h-2 sm:h-3 bg-primary rounded-full mt-1.5 sm:mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;